<template>
    <div class="hpage">
        <HorizontalText :sliderData="noticeList" @click="onClick" :totalWidth="1920" :amount="2" :height="40" />
        <div class="box1">
            <div class="b1left">
                <div style="width: 100%;">
                    <h1>{{ $t('nhome.Nu32') }}</h1>
                </div>
                <h4>{{ $t('nhome.Nu33') }}</h4>
                <div class="leftp">
                    <p>{{ $t('nhome.Nu34') }}</p>
                </div>
                <div v-if="isLogin">
                    <div style="float: right; width: 50%; ">
                        <el-button style="margin-left: 20px;" type="primary" size="small" round @click="goTrading">{{
            $t('home.login.btnText') }}</el-button>
                    </div>
                </div>
                <div v-else class="leftp3">
                    <div style="float: left; width: 50%;" class="inpCs">
                        <el-input size="small" v-model="regietrInfo"
                            :placeholder="$t('home.unlogin.placinfo')"></el-input>
                    </div>
                    <div style="float: right; width: 50%; ">
                        <el-button style="margin-left: 20px;" type="primary" size="small" round @click="goRegister">{{
            $t('home.unlogin.btnText') }}</el-button>
                    </div>
                </div>
            </div>
            <div class="b1right"></div>
        </div>
        <div class="box2">
            <div class="box2p">
                <h1>{{ $t('nhome.Nh5') }}</h1>
                <p>{{ $t('nhome.Nh6') }}</p>
            </div>
            <div class="bod">
                <div class="bodi" @click="pushl('/pages/contract/contract')">
                    <div class="bodi-bg1"></div>
                    <div class="bodi-p">
                        <h2>{{ $t('nhome.Nh7') }}</h2>
                        <p>{{ $t('nhome.Nh11') }}
                        </p>
                    </div>
                </div>
                <div class="bodi" @click="pushl('/pages/trade/trade')">
                    <div class="bodi-bg2"></div>
                    <div class="bodi-p">
                        <h2>{{ $t('nhome.Nh8') }}</h2>
                        <p>{{ $t('nhome.Nh12') }}

                        </p>
                    </div>
                </div>
                <div class="bodi" @click="pushl('/option')">
                    <div class="bodi-bg3"></div>
                    <div class="bodi-p">
                        <h2>{{ $t('nhome.Nh9') }}</h2>
                        <p>{{ $t('nhome.Nh13') }}
                        </p>
                    </div>
                </div>
                <div class="bodi" @click="pushl('/Purchase')">
                    <div class="bodi-bg4"></div>
                    <div class="bodi-p">
                        <h2>{{ $t('nhome.Nh10') }}</h2>
                        <p>{{ $t('nhome.Nh14') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="boxtab">
            <div>
                <div style="float: left; font-size: 30px;">{{ $t('nhome.Nh15') }}
                    <span style="margin-left: 30px;font-size: 16px;"
                        :style="rank == 0 ? 'color: #fcfcfd' : 'color: #61688A'" @click="ranks(0)">{{ $t('nhome.Nh29')
                        }}</span>
                    <span style="margin-left: 30px;font-size: 16px;"
                        :style="rank == 1 ? 'color: #fcfcfd' : 'color: #61688A'" @click="ranks(1)">{{ $t('nhome.Nh30')
                        }}</span>
                    <span style="margin-left: 30px;font-size: 16px;"
                        :style="rank == 2 ? 'color: #fcfcfd' : 'color: #61688A'" @click="ranks(2)">{{ $t('nhome.Nh31')
                        }}</span>
                </div>
                <div style="float: right;"> <el-button size="mini" @click="tradeclicks()">{{
            $t('nhome.Nh16') }}</el-button></div>
            </div>
            <div style="margin-top: 30px; height: 700px;">
                <el-table class="tabCss" max-height="680" :data="tablist" style=" width: 100%"
                    :row-style="{ background: '#192330', color: '#61688A' }"
                    :header-cell-style="{ background: '#192330', color: '#61688A' }">
                    <el-table-column type="index" label="#">
                    </el-table-column>
                    <el-table-column prop="s" label="Trading pairs">
                        <template slot-scope="scope">
                            <div style="height: 30px;"><img :src="scope.row.lg" alt="" style="border-radius: 50%; "
                                    width="25px"> <span style="height: 30px;line-height: 30px;"> {{
            scope.row.s }}</span></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="p" label="Price">
                        <template slot-scope="scope">
                            <span>{{ getusd(scope.row.p) }}</span>
                        </template>

                    </el-table-column>
                    <el-table-column prop="c" label="24h change">
                        <template slot-scope="scope">
                            <div :style="scope.row.c > 0 ? 'color: #00b275;' : 'color:#f15057;'">
                                {{ scope.row.c > 0 ? '⇧' : '⇩' }} {{
            (scope.row.c * 100).toFixed(2) }}%</div>
                        </template>

                    </el-table-column>
                    <el-table-column label="Trade" width="140">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="tradeclick(scope.row)">{{
            $t('home.login.btnText') }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination :page-size="pageSize" :pager-count="11" layout="prev, pager, next" :total=total
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
        </div>
        <div class="box3">
            <swiperTextTop ref="seipertop" v-if="symbolList.length" @clicktop="clicks" :sliderData="symbolList"
                :totalWidth="1920" :amount="1" :height="440" />
        </div>
        <div class="box4">
            <div style="text-align: center;">
                <h1>{{
            $t('nhome.Nh17') }}</h1>
            </div>
            <div class="b4left">
                <h1>{{
            $t('nhome.Nh18') }}</h1>
                <p>{{
            $t('nhome.Nh19') }}</p>
                <div class="b4lefti"><span class="b4lefti1"></span><span class="b4lefti1p">{{
            $t('nhome.Nh21') }}</span></div>
                <div class="b4lefti"><span class="b4lefti2"></span><span class="b4lefti1p">{{
            $t('nhome.Nh22') }}</span>
                </div>
                <div class="b4lefti"><span class="b4lefti3"></span><span class="b4lefti1p">{{
            $t('nhome.Nh23') }}</span></div>
            </div>
            <div class="b4right"></div>
        </div>
        <!-- <div class="box5">
            <div class="b5left">
            </div>
            <div class="b5right">
                <div class="b5rightp">{{
                    $t('nhome.Nh24') }}</div>
                <div class="b5rightp2">{{
                    $t('nhome.Nh25') }}</div>
            </div>
        </div> -->
        <div class="box6">
            <div class="b4left">
                <h1>{{
            $t('nhome.Nh26') }}</h1>
                <p>{{
            $t('nhome.Nh27') }}</p>
                <div class="box6top">
                    <span class="box6topbg">
                        <el-tooltip placement="top">
                            <div slot="content"><img :src="findList.registerPictureCode" alt="" width="300px"></div>
                            <img :src="findList.registerPictureCode" alt="" width="60px">
                        </el-tooltip>

                    </span>
                    <div style="margin-left: 80px;margin-top: 20px;">
                        <div style="color: #777E90 ;">IOS & Android</div>
                        <div style="font-size: 20px;">{{
            $t('nhome.Nh28') }}</div>
                    </div>
                </div>
                <div class="box6i"><span class="box6ibg1" @click="downloadApple"></span>
                    <div style="margin-left: 60px;margin-top: 10px;">
                        <div style="color: #777E90 ;">Download from</div>
                        <div style="font-size: 20px;">Appstore</div>
                    </div>
                </div>
                <div class="box6i"><span class="box6ibg2" @click="googleLink"></span>
                    <div style="margin-left: 60px;margin-top: 10px;">
                        <div style="color: #777E90 ;">Download from</div>
                        <div style="font-size: 20px;">Google Play</div>
                    </div>
                </div>
                <div class="box6i"><span class="box6ibg3" @click="downloadApk"></span>
                    <div style="margin-left: 60px;margin-top: 10px;">
                        <div style="color: #777E90 ;">Download</div>
                        <div style="font-size: 20px;">APK</div>
                    </div>
                </div>
            </div>
            <div class="b6right"></div>
        </div>
        <el-dialog :close-on-click-modal='false' :title="$t('uc.regist.pwd') + $t('uc.safe.set')"
            :visible.sync="dialogVisible" :showClose="false" width="40%">
            <div>
                <el-form label-position="left" label-width="80px" :model="form">
                    <el-form-item :label="$t('uc.regist.pwd')">
                        <el-input v-model="form.name" :placeholder="$t('uc.regist.pwdtip')"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="ok">{{
                    $t("common.ok")
                    }}</el-button>
            </span>
        </el-dialog>
        <modal-component
      :message="modalMessage"
      @confirm="handleConfirm"
      ref="ModalComponent"
    />
        <logins v-if="loginis" @loginisval="loginisvalc" :titles="loginTitle" />
        <el-dialog :close-on-click-modal='false' :title="$t('common.tip')"
            :visible.sync="notifyVisible" width="400px" :before-close="handleClosenotify">
            <div>{{notifyData}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="warning" @click="handleClosenotify">{{$t('borrow.Bo73')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import HorizontalText from '@/components/HorizontalText'
import swiperText from '@/components/swiperText'
import swiperTextTop from '@/components/swiperTextTop'
import logins from "../../components/logins.vue";
import { uniSocketMixin } from "@/components/uniSocketMixin";
import ModalComponent from '@/components/modals/index.vue'
export default {
    mixins: [uniSocketMixin],
    name: 'home',
    components: {
        HorizontalText,
        ModalComponent,
        swiperText,
        swiperTextTop,
        logins
    },
    data() {
        return {
            modalMessage:0,
            notifyData: '',
            notifyVisible: false,
            url: `${this.hostws}/flash-option/ws`,
            resetHeartbeat: false,
            websocketSwap: null, // WebSocket对象
            reconnectInterval: 1000, // 重连间隔时间（毫秒）
            heartbeatInterval: null, // 心跳定时器
            loginis: false,
            loginTitle: '1',
            dialogVisible: false,
            form: {
                name: ''
            },
            notices: ['通知公告 1', '通知公告 2', '通知公告 3', '通知公告 4', '通知公告 5', '通知公告 6', '通知公告 7', '通知公告 8', '通知公告 9', '通知公告 10', '通知公告 11', '通知公告 12', '通知公告 13', '通知公告 12', '通知公告 13', '通知公告 12', '通知公告 13', '通知公告 12', '通知公告 13', '通知公告 14', '通知公告 15', '通知公告 16', '通知公告 17', '通知公告 18', '通知公告 19', '通知公告 20', '通知公告 21'],
            scrollInterval: null,
            noticeList: [],
            findList: '',
            regietrInfo: "",
            symbolList: [],
            symbolList1: [],
            symbolList2: [],
            timer: null, //定时器
            total: null,
            tablist: [],
            pageSize: 10,
            rank: 0,
            random: '286500546',
            pageNo: 1,
            swiperOption: {
                slidesPerView: 5,
                slidesPerColumn: 2,
                slidesPerColumnFill: 'row',
                // 设置分页器
                pagination: {
                    el: '.swiper',
                    // 设置点击可切换
                    clickable: true,
                },
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                speed: 800, // 播放速度
                // loop: true, // 自动播放
                // autoplay: {
                //     delay: 0,
                //     disableOnInteraction: false,
                // },
                autoplay: {
                    delay: 0,  // 轮播间隔时间
                    stopOnLastSlide: false,  // 循环播放
                    disableOnInteraction: false,  // 用户操作后轮播仍然继续
                },
                // 轮播速度
            }
        }
    },

    created: function () {
        this.getApklinkFind()
        this.getSymbol()
        // this.getTablist()
        this.startPolling()
        // 实现轮询
        // this.timer = window.setInterval(() => {
        //     setTimeout(this.getTablist(), 0);
        //     this.random = 286500546 + Math.ceil(Math.random() * 10000)
        // }, 5000);
        this.getNotice()
        this.getSecurity()
        if (!this.configList.openContract) {
            this.connect()
            this.subscription()
        }
        if (this.isLogin) {
            this.getnotify();
        }
    },
    mounted: function () {
        // this.showModal()
        // this.modalMessage='-1'
    },

    computed: {
        configList: function () {
            return this.$store.getters.configList;
        },
        member: function () {
            return this.$store.getters.member;
        },
        isLogin: function () {
            return this.$store.getters.isLogin;
        },
        lang: function () {
            return this.$store.state.lang;
        },
    },
    methods: {

       showModal(amount) {
        if (this.$refs.ModalComponent.mdialogVisible) {
            return
        }else{ 
            this.modalMessage = amount
            this.$refs.ModalComponent.mdialogVisible = true 
         }
    },
    handleConfirm() {
      // 在这里处理确定按钮的逻辑
      this.$router.push("/option");
      console.log('确定按钮被点击了')
      // 其他逻辑...
    },
        subscription() {
            if (this.isLogin) {
                this.send({ "op": "subscribe", "arg": { "channel": "settle", "instId": this.member.id } });   
            }
           
        },
        onWebSocketMessage(event) {
            if (event) {
                const message = event;
                if (message.arg && message.data) {
                  if( message.arg.channel =='settle'){ 
                        let settles = message.data
                        this.showModal(settles.amount)
                    }
                }
            }
        },
        // getTablist() {
        //     this.$http
        //         .get(this.host + '/spot-api/market/symbol-thumb-rank' + `?pageNo=${this.pageNo}&pageSize=${this.pageSize}&rank=${this.rank}`)
        //         .then((response) => {
        //             var resp = response.body.data;
        //             this.tablist = resp.list
        //             this.total = resp.totalElements
        //         });
        // },
        // startPolling() {
        //     if (this.timer) {
        //         clearTimeout(this.timer)
        //     }
        //     this.timer = setTimeout(() => this.getTablist(), 8000);
        // },
        getnotify(){
            this.$http
                .get(this.host + '/uc/notify',)
                .then((response) => {
                    var resp = response.body;
                    if (resp.data) {
                        this.notifyVisible = true
                        this.notifyData= resp.data
                    }
                });
        },
        getInter(){
            // 轮训
            this.getTablist(); // 初始数据加载
            
        },
        startPolling() {
            this.getInter(); // 初始数据加载
            this.timer = setInterval(this.getInter, 5000); // 每5秒轮询
        },
        stopPolling() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        async getTablist() {
            try {
                const response = await this.$http.get(this.host + '/spot-api/market/symbol-thumb-rank' + `?pageNo=${this.pageNo}&pageSize=${this.pageSize}&rank=${this.rank}`);
                let data = response.data.data
                this.tablist = data.list
                this.total = parseInt(data.total)
            } catch (error) {
                console.error(error);
            }
        },
        ranks(val) {
            this.rank = val
        },
        loginisvalc(val) {
            this.loginis = val
        },
        handleislogin(val) {
            this.loginTitle = val
            this.loginis = true
        },
        getSecurity() {
            if (localStorage.getItem('ISLOGINS') == 1) {
                this.$http
                    .post(this.host + "/uc/approve/security/setting")
                    .then(response => {
                        var res = response.body;
                        if (!res.data.passwordVerified) {
                            this.dialogVisible = true
                        }
                    });
            }
        },
        ok() {
            if (!this.form.name) return this.$Message.error(this.$t("uc.regist.pwdtip"));
            this.$http
                .post(this.host + "/uc/dapp/set-password", {
                    password: this.form.name
                })
                .then(response => {
                    var res = response.body;
                    if (res.code == 0) {
                        this.dialogVisible = false
                        this.$Message.success(res.message);
                        localStorage.setItem("ISLOGINS", 0);
                    } else {
                        this.$Message.error(res.message);
                    }
                });

        },
        onClick() {

        },
        handleClosenotify() {
            this.notifyVisible = false
        },
        clicks(val) {
            console.log('ting1');
        },
        clicksss() {
            console.log('ting2');
        },
        getNotice() {
            this.$http
                .post(this.host + "/uc/announcement/page-app", {
                    pageNo: 1,
                    pageSize: 10,
                    lang: this.lang
                })
                .then(response => {
                    var resp = response.body;
                    if (resp.code == 0) {
                        this.noticeList = resp.data.list || []
                    } else {
                        this.$Message.error(resp.message);
                    }
                });
        },
        getApklinkFind() {
            this.$http
                .post(this.host + "/uc/apk-link/find")
                .then(response => {
                    var resp = response.body;
                    if (resp.code == 0) {
                        this.findList = resp.data
                    } else {
                        this.$Message.error(resp.message);
                    }
                });
        },
        downloadApple() {
            window.open(this.findList.appleLink);
        },
        downloadApk() {
            window.open(this.findList.apkLink);
        },
        googleLink() {
            window.open(this.findList.googleLink);
        },
        goRegister() {
            if (!this.regietrInfo) {
                this.$router.push("/register");
                return;
            }
            let type = 1;
            if (/^\d+$/g.test(this.regietrInfo)) {
                type = 0;
            }
            this.$router.push({
                path: "/register",
                query: { data: this.regietrInfo, type },
            });
        },
        goTrading() {
            this.$router.push({ path: "/pages/trade/trade" });
        },
        swiperclick() {
            this.$router.push('/pages/trade/trade');
        },
        tradeclicks() {
            this.$router.push('/pages/trade/trade');
        },
        tradeclick(row) {
            this.$router.push(
                {
                    path: '/pages/trade/trade',
                });
        },
        pushl(val) {
            this.$router.push(val);
        },
        handleCurrentChange(val) {
            this.pageSize = 10
            this.pageNo = val
            this.getTablist()
        },

        getSymbol() {
            this.$http
                .get(this.host + '/spot-api/market/symbol-thumb-kline?limit=30',)
                .then((response) => {
                    var resp = response.body;
                    this.symbolList = resp.data
                });
        },
        // onSwiper() {
        // },
        // onSlideChange() {
        // },
    },
    destroyed() {
        this.socketClear();
        // this.closeWebSocket(); // 在组件销毁前关闭WebSocket连接
    },
    beforeDestroy() {
        this.stopPolling()
        //离开页面是销毁
        // clearTimeout(this.timer);
        // this.timer = null;
    },
    // 轮询结束-------------
}
</script>
<style>
.inpCs .el-input__inner {
    background: #192330 !important;
    color: #61688A !important;
}
</style>

<style scoped lang="scss">
// 卡片
// @media screen and (min-width: 1920px) {
//     .new-list_new-list-content__fenpr {
//         --new-list-shadow-width: 25%;
//     }
// }

// .horizontal-swipe_horizontal-swipe__ARSJM {
//     left: 0;
//     transform: translateX(0);
// }

// .horizontal-swipe_horizontal-swipe-fill-content__before__u5sKR {
//     left: 0;
//     transform: translateX(30);
// }

// .horizontal-swipe_horizontal-swipe__ARSJM .horizontal-swipe_horizontal-swipe-fill-content__oNlw4 {
//     position: absolute;
//     top: 0;
//     width: auto;
//     white-space: nowrap;

// }

// .new-list_new-list-content__fenpr {
//     --new-list-shadow-width: 120px;
//     position: relative;
//     z-index: 0;
// }

// .horizontal-swipe .horizontal-swipe_horizontal-swipe__ARSJM {
//     overflow: hidden
// }

// .horizontal-swipe_horizontal-swipe__ARSJM .horizontal-swipe_horizontal-swipe-content__emqF_ {
//     position: relative;
//     display: inline-flex;
//     white-space: nowrap;
//     animation: horizontal-swipe_marquee__ry3e4 60s linear infinite;
//     overflow: visible;
// }

// .horizontal-swipe_animation-state__running__2yE3M {
//     animation-play-state: running !important;
// }

// .new-list-item_home-new-item__MMsS4 {
//     display: inline-block;
//     margin: 0 12px;
//     padding: 16px 20px;
//     border-radius: 12px;
//     border: 1px solid var(--divider-primary);
//     background: palevioletred;
// }

.home-new-item {
    touch-action: manipulation;
}

.hpage {
    background: #192430;
    height: auto;
    text-align: left;
    color: #FCFCFD;
}

.box1 {
    margin: 0 13%;
    padding-top: 40px;
    height: 550px;

}

.leftp {
    width: 420px;
    color: #777E90;
}

.b1left {
    width: 40%;
    float: left;
}

.leftp3 {
    margin-top: 20px;
    width: 100%;
}

.leftp2 {
    height: 140px;
}

.b4left {
    width: 50%;
    float: left;

}

.b4lefti {
    height: 60px;
    margin: 20px 0;
}

.b4right {
    width: 50%;
    float: right;
    height: 400px;
    background: #192430 url(../../assets/images/hbox4bg.png) 0 0/100% 369px no-repeat;
}

.b4lefti1p {
    line-height: 64px;
    font-size: 20px;
    margin-left: 20px;
}

.b4lefti1 {
    display: block;
    width: 60px;
    height: 60px;
    background: #192430 url(../../assets/images/b4lefti1.png) 0 0/100% 60px no-repeat;
    float: left;
}

.b4lefti2 {
    display: block;
    width: 60px;
    height: 60px;
    background: #192430 url(../../assets/images/b4lefti2.png) 0 0/100% 60px no-repeat;
    float: left;
}

.b4lefti3 {
    display: block;
    width: 60px;
    height: 60px;
    background: #192430 url(../../assets/images/b4lefti3.png) 0 0/100% 60px no-repeat;
    float: left;
}

.b1right {
    float: right;
    width: 50%;
    height: 502px;
    background: #192430 url(../../assets/images/home-boxbg.png) 0 0/100% 470px no-repeat;
}

.box2 {
    margin: 0 15%;
    padding-top: 40px;
    background: #252C39;
    height: 580px;
    border-radius: 25px;

}

.box2p {
    text-align: center;
}

.bod {
    display: flex;
}

.bodi {
    flex: 1;
    // background: #000;
    height: 430px;
    margin: 0 20px;
    width: 80%;
    border-radius: 10px;
}

.bodi:hover {
    background: #000;
}

.bodi-bg1 {
    height: 240px;
    background: url(../../assets/images/hbg1.png) 0px 0px/100% 200px no-repeat;
}

.bodi-bg2 {
    height: 240px;
    background: url(../../assets/images/bhg2.png) 0px 0px/100% 200px no-repeat;
}

.bodi-bg3 {
    height: 240px;
    background: url(../../assets/images/hbg3.png) 0px 0px/100% 200px no-repeat;
}

.bodi-bg4 {
    height: 240px;
    background: url(../../assets/images/hbg4.png) 0px 6px/100% 200px no-repeat;
}

.bodi-p {
    text-align: center;
    margin: 0 20px;
}

.box4 {
    margin: 0 13%;
    margin-top: 30px;
    height: 700px;
}

// .box5 {
//     margin: 0 13%;
//     margin-top: 30px;
//     height: 600px;

// }

.b5left {
    float: left;
    width: 50%;
    height: 540px;
    background: #192430 url(../../assets/images/hb5bg.png) 0 0/100% 376px no-repeat;
}

.b5right {
    float: right;
    width: 50%;
}

.b5rightp {
    margin-top: 60px;
    font-size: 40px;
    width: 380px;
}

.b5rightp2 {
    margin-top: 20px;
    width: 380px;
}

.box6 {
    margin: 0 13%;
    // margin-top: 30px;
    height: 700px;

}

.b6right {
    float: right;
    width: 50%;
    height: 668px;
    background: #192430 url(../../assets/images/hb6bg.png) 0 0/100% 668px no-repeat;
}

.box6ibg1 {
    display: block;
    margin-top: 14px;
    width: 40px;
    height: 40px;
    background: #192430 url(../../assets/images/box6bg3.png) 0 0/100% 40px no-repeat;
    float: left;

}

.box6ibg2 {
    display: block;
    margin-top: 14px;
    width: 40px;
    height: 40px;
    background: #192430 url(../../assets/images/box6bg1.png) 0 0/100% 40px no-repeat;
    float: left;

}

.box6ibg3 {
    display: block;
    margin-top: 14px;
    width: 40px;
    height: 40px;
    background: #192430 url(../../assets/images/box6bg2.png) 0 0/100% 40px no-repeat;
    float: left;

}

.box6i {
    height: 60px;
    margin: 20px 0;
    width: 400px;
    border-top: #353945 0.5px solid;

}

.box6top {
    height: 60px;
    margin: 20px 0;
    width: 400px;
    margin-top: 40px;

}

.box6topbg {
    float: left;
}

.boxtab {
    margin: 50px 13%;
}

.box3 {
    height: 500px;
    // padding-left: 100px;
}

.swipersty {
    width: 18%;
    height: 180px;
    background: #2F3241;
    margin-left: 10px;
    margin-bottom: 20px;
    border-radius: 5px;
}

.swipersty:hover {
    background: #000;

}

.swipersty:first-child {
    margin-left: 300px;
}

.block {
    margin-top: 10px;
    float: right;
    margin-right: 10px;
}

.swiper-container .swiper-wrapper {
    -webkit-transition-timing-function: linear;
    /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
}

.scroll-container {
    width: 1920px;
    overflow: hidden;
    position: relative;
}

.scroll-content {
    white-space: nowrap;
}

.scroll-content ul {
    display: inline-block;
    // padding: 0;
    // margin: 0;
    // list-style: none;
    margin-left: 20px;
    width: 200px;
    animation: scroll 10s linear infinite;
}

.scroll-content:hover ul {
    animation-play-state: paused;
}

@keyframes scroll {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-100%);
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/newHome/index.vue